import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// i18n Configuration
import './i18n/config';

// Componente
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pagini
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProcessPage from './pages/ProcessPage';
import ContactPage from './pages/ContactPage';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/despre-noi" element={<AboutPage />} />
            <Route path="/procesul" element={<ProcessPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
      </Router>
  );
}

export default App;
